import { createStore } from "vuex";
const getToken = () => {
  const result = localStorage.getItem("token");
  return result ? result : "";
};
export default createStore({
  state: {
    token: getToken(),
  },
  getters: {},
  mutations: {
    setToken(state, val) {
      state.token = val;
      localStorage.setItem("token", val);
    },
  },
  actions: {},
  modules: {},
});
